// extracted by mini-css-extract-plugin
export default {"inputStyle":"src-components-Antd-Input-Input__inputStyle--tENvB"};